/* @flow */
type TypeApiEndpoints = typeof endpoints;

const endpoints = {
  accounts: 'accounts',
  accountsDropdown: 'accounts/dropdown',
  brandAssignment: brandId => `brands/${brandId}/assignable-brands`,
  contracts: 'contracts',
  products: 'products',
  accountAssets: 'assets',
  defaultAddress: (accountId: string) => `accounts/${accountId}/default-location`,
  locations: 'locations',
  states: 'states',
  manufacturers: 'manufacturers',
  manufacturersForUsers: 'manufacturers/list-for-user',
  manufacturersForAccounts: 'manufacturers/accounts',
  manufacturerProducts: 'products/manufacturers',
  manufacturerProductsForUsers: 'products/list-for-user',
  manufacturerProductsForManufacturer: 'products/account-manufacturer',
  projects: 'projects',
  users: 'users',
  costCenter: 'cost-centres',
  companies: 'companies',
  erCompanies: 'er-companies-master',
  countries: 'countries',
  requestForm: {
    all: {
      accounts: 'accounts?only_enabled=true&search=asset_license_request_form_enabled:true',
    },
    asset: {
      accounts: 'accounts?only_enabled=true&search=asset_request_form_enabled:true',
    },
    rushAsset: {
      accounts: 'accounts?only_enabled=true&is_rush_asset_request_form_customer=true',
    },
    license: {
      accounts: 'accounts?only_enabled=true&search=license_request_form_enabled:true',
      types: 'license-request-types',
    },
  },
  rushAssetCatalogue: 'rush-asset-request/catalogue',
};

export default endpoints;
